import CustomTextUrlFieldInput from './CustomTextUrlFieldInput';

// Create a module object that contains your custom components
const FormioCustomComponents = {
  components: {
    customtextUrlFieldInput: CustomTextUrlFieldInput
  }
};

// Export the module for use elsewhere
export default FormioCustomComponents;